import React, { Component } from "react";

/**
 * ErrorBoundary dédié aux erreurs de chargement de chunks (lazy loading).
 *
 * Quand un chunk manque (déploiement en cours, cache obsolète du navigateur),
 * on recharge automatiquement la page UNE fois pour récupérer le nouveau build.
 * Si le problème persiste, on affiche un message clair avec un lien de retour.
 */
export default class ChunkErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false, reloaded: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    const msg = String((error && error.message) || error);
    const isChunkError =
      /Loading chunk [\w.]+ failed|ChunkLoadError|failed to fetch dynamically imported module/i.test(msg);

    if (isChunkError && !this.state.reloaded) {
      // Un seul rechargement automatique pour éviter une boucle infinie
      this.setState({ reloaded: true });
      window.location.reload();
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.failed) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
            <div className="text-5xl mb-4">🔄</div>
            <h1 className="text-xl font-bold text-gray-800 mb-2">
              Mise à jour en cours…
            </h1>
            <p className="text-sm text-gray-500 mb-6">
              Une nouvelle version du site a été déployée. Rechargez la page pour continuer.
            </p>
            <button
              onClick={this.handleReload}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-xl transition"
            >
              Recharger la page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}